/**
 * observe.js — scroll-reveal engine.
 *
 * Adds `.inview` to every `.animate` / `.animateTb` element the first time it
 * scrolls into view, then stops watching it. One shared IntersectionObserver
 * handles the whole page (the old code spun up one observer per element and
 * never disconnected, so it kept firing on every scroll). Motion + the
 * reduced-motion fallback live in css/animate.scss.
 *
 * A `.Fact.Overview` entering view also kicks off any `.countup` numbers inside
 * it (facts block); count-up is opt-in via the `.countup` class.
 */
( function () {
	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	const revealObserver = new IntersectionObserver( ( entries, observer ) => {
		entries.forEach( ( entry ) => {
			if ( ! entry.isIntersecting ) return;

			const el = entry.target;
			el.classList.add( 'inview' );
			observer.unobserve( el );   // reveal once, then forget it

			if ( el.classList.contains( 'Fact' ) && el.classList.contains( 'Overview' ) ) {
				el.querySelectorAll( '.countup' ).forEach( animateCountUp );
			}
		} );
	}, {
		threshold: 0.12,   // fire as the element starts entering the viewport
	} );

	document.querySelectorAll( '.animate, .animateTb' ).forEach( ( el ) => revealObserver.observe( el ) );

	/**
	 * Count a number up from 0 to its printed value (easeOutQuint). Runs once
	 * per element (guarded by data-counted); the target is captured from the
	 * initial text so a re-entry can't read a partial value. Under
	 * prefers-reduced-motion the final value is set immediately.
	 */
	const DURATION = 1600;                       // ms
	const FRAME = 1000 / 60;                      // ~60fps
	const TOTAL_FRAMES = Math.round( DURATION / FRAME );
	const easeOutQuint = ( t ) => 1 - Math.pow( 1 - t, 5 );

	function animateCountUp( el ) {
		if ( el.dataset.counted ) return;
		el.dataset.counted = '1';

		const target = parseInt( el.dataset.countup || el.textContent, 10 );
		if ( isNaN( target ) ) return;

		if ( prefersReducedMotion ) {
			el.textContent = String( target );
			return;
		}

		let frame = 0;
		const counter = setInterval( () => {
			frame++;
			const value = Math.round( target * easeOutQuint( frame / TOTAL_FRAMES ) );
			if ( parseInt( el.textContent, 10 ) !== value ) {
				el.textContent = String( value );
			}
			if ( frame >= TOTAL_FRAMES ) {
				el.textContent = String( target );
				clearInterval( counter );
			}
		}, FRAME );
	}
} )();
